/* Feminine: expired campaign suppression, Danish UpCart labels and count synchronization. */
(() => {
  const roots = new WeakSet();
  function attach() {
    const root = document.getElementById('upCart')?.shadowRoot;
    if (!root || roots.has(root)) return;
    roots.add(root);
    const style = document.createElement('style');
    style.textContent = '.upcart-public-rewards__bar{display:none!important}.upcart-public-product-properties__item,.upcart-public-cart-items__key-value-pair{color:#1d1a16!important}.upcart-public-discount-code__form:has(input[placeholder^="NYWEBSHOP"]){display:none!important}';
    root.appendChild(style);
    function localize() {
      const shippingMessage = root.querySelector('.upcart-public-rewards__message');
      if (shippingMessage && shippingMessage.textContent !== 'Fri fragt i Danmark fra 1.000 kr. efter rabatter.') shippingMessage.textContent = 'Fri fragt i Danmark fra 1.000 kr. efter rabatter.';
      // The free-sample campaign belonged to the previous launch.
      root.querySelectorAll('p').forEach(el => {
        const text = el.textContent.trim();
        if (text === 'Fri fragt fra 1.000 kr. · Valgfri prøve fra 1.500 kr.') el.textContent = 'Fri fragt fra 1.000 kr.';
        if (text === 'En gave til dig ved køb fra 1.500 kr. Vælg én gratis prøve, som vi lægger i din pakke.') el.textContent = 'Bemærkning til din ordre';
      });
      root.querySelectorAll('h1,h2,h3,h4,p,span,div').forEach(el => {
        if (el.children.length === 0 && el.textContent.trim() === 'Fuldend dit ritual') {
          el.textContent = 'Fuldend din rutine';
        }
      });
      const labels = {
        'Close cart': 'Luk kurven',
        'Decrease quantity': 'Reducer antal',
        'Increase quantity': 'Øg antal',
        'Product quantity': 'Antal',
        'Product carousel': 'Produktforslag',
        'Previous slide': 'Forrige',
        'Next slide': 'Næste'
      };
      root.querySelectorAll('[aria-label]').forEach(el => {
        const current = el.getAttribute('aria-label');
        let translated = labels[current];
        if (!translated && el.classList.contains('upcart-public-component-product-tile__remove-button') && current?.startsWith('Remove ')) {
          translated = 'Fjern ' + current.slice(7);
        }
        if (!translated && el.tagName === 'SELECT' && current?.startsWith('Select ') && current.endsWith(' variant')) {
          translated = 'Vælg variant af ' + current.slice(7, -8);
        }
        if (!translated && el.classList.contains('upcart-public-component-carousel__slide')) {
          const slide = /^Slide (\d+) of (\d+)$/.exec(current || '');
          if (slide) translated = 'Produkt ' + slide[1] + ' af ' + slide[2];
        }
        if (translated && current !== translated) el.setAttribute('aria-label', translated);
      });
      root.querySelectorAll('textarea[placeholder="Lip stain 4 g, Volume Mascara eller 3 teprøver"], textarea[data-feminine-order-note="true"]').forEach(el => {
        el.setAttribute('data-feminine-order-note', 'true');
        if (el.placeholder !== 'Bemærkning til din ordre') el.placeholder = 'Bemærkning til din ordre';
        if (el.getAttribute('aria-label') !== 'Bemærkning til din ordre') el.setAttribute('aria-label', 'Bemærkning til din ordre');
        if (!el.id) el.id = 'FeminineGiftNote';
        const toggle = el.closest('.upcart-public-notes')?.querySelector('.upcart-public-component-collapse__dropdown-container');
        if (toggle && toggle.tagName !== 'BUTTON') {
          const attributes = {
            'role': 'button', 'tabindex': '0', 'aria-label': 'Ordrebemærkning',
            'aria-controls': el.id, 'data-feminine-gift-toggle': 'true',
            'aria-expanded': toggle.querySelector('[data-expanded]')?.getAttribute('data-expanded') === 'true' ? 'true' : 'false'
          };
          Object.entries(attributes).forEach(([name, value]) => {
            if (toggle.getAttribute(name) !== value) toggle.setAttribute(name, value);
          });
        }
      });
      const hidden = {...labels, 'Price': 'Pris', 'Subtotal': 'Subtotal'};
      root.querySelectorAll('.upcart-internal__visually-hidden').forEach(el => {
        const current = el.textContent.trim();
        const translated = hidden[current];
        if (translated && current !== translated) el.textContent = translated;
      });
    }
    function sync() {
      localize();
      const christmasHandles = ["team-dr-joseph-a-christmas-wish-kit","team-dr-joseph-the-ultimate-radience-duo","team-dr-joseph-the-ultimate-body-duo","team-dr-joseph-the-ultimate-repair-ritual","team-dr-joseph-the-ultimate-calming-duo","team-dr-joseph-the-ultimate-freshness-duo"];
      const hasChristmasKit = [...root.querySelectorAll('.upcart-public-cart-items a[href]')].some(link => christmasHandles.some(handle => link.getAttribute('href').split('?')[0].endsWith('/products/' + handle)));
      let christmasNotice = root.querySelector('[data-feminine-christmas-delivery]');
      const checkout = root.querySelector('.upcart-checkout-button-container');
      if (hasChristmasKit && checkout && !christmasNotice) {
        christmasNotice = document.createElement('p');
        christmasNotice.setAttribute('data-feminine-christmas-delivery', 'true');
        christmasNotice.style.cssText = 'margin:12px 0;padding:12px;border:1px solid #c5b9a9;font-size:13px;line-height:1.5;color:inherit';
        christmasNotice.textContent = 'Julekits på forudbestilling forventes hjemme i butikken i uge 41–43 og sendes, så snart de lander. Ved levering sender vi hele ordren samlet, når alle dine julekits er hjemme. Ønsker du andre varer tidligere, skal du lægge to separate ordrer med almindelig fragt pr. ordre.';
        checkout.before(christmasNotice);
      }
      if (christmasNotice && !hasChristmasKit) christmasNotice.remove();
      const inputs = [...root.querySelectorAll('input[aria-label="Product quantity"], input[aria-label="Antal"]')];
      if (inputs.some(input => input.disabled)) return;
      const empty = [...root.querySelectorAll('h3')].some(el => el.textContent.trim() === 'Din kurv er tom');
      if (!inputs.length && !empty) return;
      const count = inputs.reduce((sum, input) => sum + (parseInt(input.value, 10) || 0), 0);
      document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        if (bubble.textContent.trim() !== String(count)) bubble.textContent = String(count);
      });
    }
    new MutationObserver(sync).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['value','disabled','aria-label','data-expanded']});
    root.addEventListener('keydown', event => {
      const target = event.target;
      if (target?.matches?.('[data-feminine-gift-toggle="true"]') && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        target.click();
      }
    });
    root.addEventListener('change', sync);
    sync();
  }
  new MutationObserver(attach).observe(document.documentElement, {childList:true,subtree:true});
  let tries = 0;
  const timer = setInterval(() => { attach(); if (++tries >= 120) clearInterval(timer); }, 250);
  attach();
})();
